exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* smartphones, iPhone, portrait 480x320 phones */\n/* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */\n/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n/* tablet, landscape iPad, lo-res laptops ands desktops */\n/* big landscape tablets, laptops, and desktops */\n/* hi-res laptops and desktops */\n.range-inner {\n  width: 100%;\n  height: 10px;\n  border-radius: 10px;\n  background: #BE0000;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  overflow: hidden; }\n\n.marker {\n  pointer-events: all;\n  width: 200px;\n  height: 200px;\n  background: #BE0000;\n  margin-left: -100px;\n  margin-top: -95px;\n  border-radius: 100%;\n  position: absolute;\n  -webkit-transform: scale(0.1);\n          transform: scale(0.1);\n  transition: -webkit-transform 0.15s linear;\n  transition: transform 0.15s linear;\n  transition: transform 0.15s linear, -webkit-transform 0.15s linear; }\n\n.marker.active {\n  -webkit-transform: scale(0.15);\n          transform: scale(0.15); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/range-slider/range-slider.component.scss
// module id = ./src/app/components/range-slider/range-slider.component.scss
// module chunks = main